var addButtons = document.querySelectorAll('[data-sunday-reading-add]');

// EU/EEA/UK right-of-withdrawal waiver for DIGITAL subscribe buttons only.
// A button is digital when it carries data-eu-digital="true" (set server-side from
// variant.requires_shipping == false). Region readiness is provided by window.EUWithdrawal
// (snippets/eu-geo.liquid). The add is deferred until the region is known, so a fast click
// can never bypass the consent gate. Physical products (e.g. The Hearth) are never flagged.

var EU_WAIVER_VALUE = 'Consented: requested immediate access; 14-day right of withdrawal waived once access begins (for a service such as a reading, once fully performed).';
var EU_WAIVER_LABEL = 'I request immediate access and waive my 14-day right of withdrawal once it begins (for a reading, once fully performed).';

function addSubscription(variantID, subscriptionID, properties) {
    var formData = {
        'id': variantID,
        'selling_plan': subscriptionID,
        'quantity': 1
    };
    if (properties) { formData.properties = properties; }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData)
    })
    .then(function (response) {
        var refreshCart = new CustomEvent('apps:product-added-to-cart');
        document.dispatchEvent(refreshCart);
        var icon = document.querySelector('[data-js-cart-icon]');
        if (icon) { icon.click(); }
    })
    .catch(function (error) {
      console.log(error);
    });
  }

// Inject (once) a compact required consent checkbox + inline error next to a digital button.
function ensureWaiver(btn) {
    if (btn._euWaiverBox) { return btn._euWaiverBox; }
    var container = document.createElement('div');
    container.className = 'eu-sub-waiver';
    container.style.cssText = 'margin:.55rem auto 1.4rem;max-width:30rem;text-align:left;';
    var label = document.createElement('label');
    label.style.cssText = 'display:flex;gap:.45rem;align-items:flex-start;font-size:.72rem;line-height:1.3;cursor:pointer;';
    var cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.setAttribute('data-eu-sub-waiver', '');
    var span = document.createElement('span');
    span.textContent = EU_WAIVER_LABEL;
    label.appendChild(cb);
    label.appendChild(span);
    var err = document.createElement('p');
    err.setAttribute('data-eu-sub-waiver-error', '');
    err.textContent = 'Please check the box above to subscribe.';
    err.style.cssText = 'display:none;color:#ff6b6b;font-size:.72rem;margin:.3rem 0 0 1.45rem;';
    container.appendChild(label);
    container.appendChild(err);
    cb.addEventListener('change', function () { if (cb.checked) { err.style.display = 'none'; } });
    btn.parentNode.insertBefore(container, btn.nextSibling);
    btn._euWaiverBox = cb;
    btn._euWaiverErr = err;
    return cb;
}

function revealConsents() {
    for (var j = 0; j < addButtons.length; j++) {
        if (addButtons[j].dataset.euDigital === 'true') { ensureWaiver(addButtons[j]); }
    }
}

for (let i = 0; i < addButtons.length; i++) {
    addButtons[i].addEventListener("click", function(e) {
        var btn = e.currentTarget;
        var variantID = btn.dataset.variant;
        var subscriptionID = btn.dataset.subscribe;

        if (btn.dataset.euDigital !== 'true') {
            addSubscription(variantID, subscriptionID);          // not digital -> add normally
            return;
        }

        var gate = (window.EUWithdrawal && window.EUWithdrawal.ready) || Promise.resolve(false);
        gate.then(function () {                                   // wait until region is known
            if (!(window.EUWithdrawal && window.EUWithdrawal.isEU)) {
                addSubscription(variantID, subscriptionID);      // non-EU -> add normally
                return;
            }
            var box = ensureWaiver(btn);
            if (!box.checked) {
                if (btn._euWaiverErr) { btn._euWaiverErr.style.display = 'block'; }
                try { box.focus(); } catch (x) {}
                return;
            }
            if (btn._euWaiverErr) { btn._euWaiverErr.style.display = 'none'; }
            addSubscription(variantID, subscriptionID, { 'Withdrawal waiver': EU_WAIVER_VALUE });
        });
    });
}

// Show the consent upfront for EU visitors (don't wait for a click).
if (document.documentElement.classList.contains('is-eu-withdrawal')) { revealConsents(); }
document.addEventListener('eu-withdrawal:active', revealConsents);
